import { FC } from 'react';
// MUI
import { Box, Typography } from '@mui/material';

const Footer:FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box component="footer" sx={{ py: 2, px: 4 }}>
      <Typography sx={{ fontWeight: 500 }}>
        {`©${currentYear} Case Chronology®. All rights reserved`}
      </Typography>
    </Box>
  );
}

export default Footer;
